module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av404-4a169709a5ffdf99a40b8c4cfc09fdcb.jpg";